import { useContext, useEffect, useMemo, useState } from 'react'
import { Logger } from '@wolfdanepug/common-react'
import { Box, Input } from '@mui/material'
import PlanProductItem from './PlanProductItem'
import { OnboardingContext } from '../../context/onboarding/OnboardingContext'

export default function PlanBuilder({
	suggestedProducts,
	recommendedProduct,
	plan,
	discountConfiguration
}: any) {
	const { setCanStepForward } = useContext(OnboardingContext)
	const [selectedProducts, setSelectedProducts] = useState<string[]>(
		plan?.products || [recommendedProduct?.id]
	)

	const products = useMemo(() => {
		if (!suggestedProducts) return []
		// Group products by price
		const productsByPrice =
			suggestedProducts.reduce((acc: any, product: any) => {
				const price = product.price
				if (!acc[price]) acc[price] = []
				acc[price].push(product)
				return acc
			}, {}) || {}

		// convert productsByPrice to array
		return Object.entries(productsByPrice).map(([price, products]: any) => ({
			price,
			products
		}))
	}, [suggestedProducts])

	useEffect(() => {
		Logger.log('[PlanBuilder] recommendedProduct', recommendedProduct)
	}, [recommendedProduct])

	useEffect(() => {
		Logger.log('[PlanBuilder] suggestedProducts', suggestedProducts)
	}, [suggestedProducts])

	useEffect(() => {
		Logger.log('[PlanBuilder] selectedProducts', selectedProducts)
	}, [selectedProducts])

	useEffect(() => {
		Logger.log('[PlanBuilder] products', products)
	}, [products])

	useEffect(() => {
		setCanStepForward(selectedProducts.length > 0)
	}, [selectedProducts])

	const onProductChange = (selected: boolean, product: any) => {
		selected
			? setSelectedProducts([...selectedProducts, product.id])
			: setSelectedProducts(selectedProducts.filter((id) => id !== product.id))
	}

	return (
		<>
			{plan?.id && <Input type="hidden" name="plan" value={plan?.id} />}
			{selectedProducts.length > 0 &&
				selectedProducts.map((product: string, index: number) => (
					<Input
						key={`products-field-${index}`}
						type="hidden"
						name={`products[${index}]`}
						value={product}
					/>
				))}

			<Box sx={{ display: 'flex', flexDirection: 'row', gap: 6 }}>
				{products?.length > 0 &&
					products.map((group: any, idx: number) => (
						<PlanProductItem
							key={`product-group-${idx}`}
							group={group}
							selectedProducts={selectedProducts}
							discountConfiguration={discountConfiguration}
							onChange={onProductChange}
						/>
					))}
			</Box>
		</>
	)
}
